import {
  CommandCentreOperator,
  CommandCentrePosition,
  OperatorStatus,
} from '@/types';

function presenceToStatus(
  presence: CommandCentrePosition['presence'],
): OperatorStatus {
  return presence === 'Offline' ? 'Offline' : 'Live';
}

/**
 * Table rows = operators GET plus anyone who already has a map position
 * for the selected site (new trackers appear before the operators refetch).
 */
export function mergeOperatorsWithSitePositions(
  operators: CommandCentreOperator[],
  positions: CommandCentrePosition[],
  fallbackName: (operatorId: number) => string,
): CommandCentreOperator[] {
  const byId = new Map(
    operators.map((operator) => [operator.userId, operator]),
  );

  for (const position of positions) {
    if (byId.has(position.operatorId)) continue;

    byId.set(position.operatorId, {
      userId: position.operatorId,
      displayName: fallbackName(position.operatorId),
      workratePercent: 0,
      jobsAssigned: 0,
      jobsCompleted: 0,
      currentStatus: presenceToStatus(position.presence),
      metresCovered: 0,
      workToRestRatio: '0:0',
      latitude: position.lat,
      longitude: position.lng,
    });
  }

  return [...byId.values()].sort(
    (a, b) => b.workratePercent - a.workratePercent,
  );
}
